import assets from 'modules/assets';
import qs from 'query-string';
import React from 'react';
import styles from './index.module.scss';

export default function Subscribe() {
  const { type } = qs.parse(window.location.search);

  // 铲车或挖机
  const isCc = type === 'cc';

  return (
    <div className={styles.container}>
      <div className={styles.title}>请扫码参与</div>
      <img className={styles.pointer} src={assets.invitationGift.pointer} />
      <img
        className={styles.qrcode}
        src={
          isCc ? assets.invitationGift.ccQrcode : assets.invitationGift.wjQrcode
        }
      />
    </div>
  );
}
